import { useQuery } from "@tanstack/react-query";
import { REFRESH_INTERVAL } from "../models/constants";
import { getCampaignData } from "../repositories/MillSetupRepository";

export const useCampaignData = () => {
	return useQuery({
		queryKey: ["millSetup", "campaign"],
		queryFn: ({ signal }) => getCampaignData(signal),
		refetchInterval: REFRESH_INTERVAL,
		staleTime: REFRESH_INTERVAL - 1000,
		retry: false,
		refetchOnWindowFocus: false,
	});
};
